import React from "react";
import { CADENCE_OPTIONS, cadenceKey } from "./taskHubUtils";

// One-off / Daily / Weekly / Monthly segmented control with the number of
// active tasks in each cadence.
export default function OverviewSegRow({ planTasks, storeId, cadence, onChange, summary }) {
  const counts = {};
  (planTasks || []).forEach((t) => {
    if ((t.status || "draft") !== "active" || t.is_archived) return;
    // The library is company-wide; count only what runs at THIS store.
    if (
      storeId != null &&
      t.is_location_specific &&
      !(t.location_specific_stores || []).map(Number).includes(Number(storeId))
    ) {
      return;
    }
    const key = cadenceKey(t);
    counts[key] = (counts[key] || 0) + 1;
  });
  const ordered = [
    CADENCE_OPTIONS.find((o) => o.key === "one_off"),
    ...CADENCE_OPTIONS.filter((o) => o.key !== "one_off"),
  ];
  return (
    <div className="flex items-center justify-between mb-3">
      <div className="inline-flex gap-1 bg-slate-100 rounded-xl p-1">
        {ordered.map((o) => (
          <button
            key={o.key}
            onClick={() => onChange(o.key)}
            className={`px-3.5 py-1.5 rounded-lg text-[13px] font-semibold whitespace-nowrap transition-colors ${
              cadence === o.key ? "bg-violet-700 text-white shadow-sm" : "text-slate-600 hover:bg-white"
            }`}
          >
            {o.label} <span className="opacity-70 font-medium">{counts[o.key] || 0}</span>
          </button>
        ))}
      </div>
      {summary && <div className="text-sm text-slate-600">{summary}</div>}
    </div>
  );
}
